const doc = [({"body":"Körperliches Wohlbefinden", "psyche":"Psychisches Wohlbefinden", "sex":"Sexuelles Wohlbefinden"})];
module.exports = doc.length <= 1 ? doc[0] : doc;